module.exports = __webpack_public_path__ + "media/stylesheets/images/main/person_you-26490d83a7fcee2f12314b82c10964ca.png";